export default "__VITE_ASSET__DgXzyu7t__"